import { ViewColumnTemplateFragment } from 'types/graphql'

/**
 * FE mirror of the BE `resolveColumnDisplayLabel`
 * (`api/src/services/views/column-template.ts`).
 *
 * Used by the in-drawer MobX getter `TableViewColumn.displayLabel` so
 * popover renames repaint the report-preview header before the save
 * round-trip lands a fresh `Report.lineItemColumns[].displayLabel` from
 * the BE. Keep the trim/whitespace fallback chain in lockstep with the
 * BE helper — drift here means the same column shows different labels
 * pre- vs. post-save.
 */
export const resolveColumnDisplayLabel = (
  override: string | null | undefined,
  columnTemplate: ViewColumnTemplateFragment
): string => {
  const trimmed = override?.trim()
  if (trimmed) {
    return trimmed
  }
  return columnTemplate.labelTitleCase
}
